import React from 'react';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Box } from 'fw/components';
import * as API from 'modules/app/API'
import DirectAPI from 'fw/system/API'
import { Row, Col, Button, Glyphicon } from 'react-bootstrap';

class ReportManagement extends React.Component {

    getDemographicsReport = () => {
        API.App.get('/reportManagement/getDemographicsReport', {}, {
            success: (sr) => {
                new DirectAPI().download(sr.data)
            }
        })
    }

    getContactReport = () => {
        API.App.get('/reportManagement/getContactReport', {}, {
            success: (sr) => {
                new DirectAPI().download(sr.data)
            }
        })
    }

	getAppProductionReport = () => {
        API.App.get('/reportManagement/getAppProductionReport', {}, {
            success: (sr) => {
                new DirectAPI().download(sr.data)
            }
        })
	}

	getDiscountCodeReport = () => {
		API.Admin.post('/discountCodeDashboard/getDiscountCodeExecutiveReportExport', {}, {
			success: (sr) => {
				new DirectAPI().download(sr.data);
			}
		});
	}

	getPayPalVOBReport = () => {
		API.App.get('/reportManagement/getPayPalVOBReport', {}, {
			success: (sr) => {
				new DirectAPI().download(sr.data);
			}
		});
	}

	getDenialReport = () => {
		API.App.get('/reportManagement/getDenialReport', {}, {
			success: (sr) => {
				new DirectAPI().download(sr.data);
			}
		});
	}

    render() {
        return (
            <React.Fragment>
                <ContentHeader title="Report Management">
                </ContentHeader>
                <ContentBody>
                    <Box boxStyle="primary">
                        <Row>
                            <Col md={2} style={{ marginTop: 10 }}>Demographics Report</Col>
                            <Col md={2}>
                                <Button onClick={this.getDemographicsReport} className="btn btn-default pull-left" style={{ marginTop: 5 }}>
                                    <Glyphicon glyph="glyphicon glyphicon-export" style={{ marginRight: 10 }} />
                                    Get Report
                                </Button>
                            </Col>
                        </Row>
						<Row>
                            <Col md={2} style={{ marginTop: 10 }}>Contact Report</Col>
                            <Col md={2}>
                                <Button onClick={this.getContactReport} className="btn btn-default pull-left" style={{ marginTop: 5 }}>
                                    <Glyphicon glyph="glyphicon glyphicon-export" style={{ marginRight: 10 }} />
                                    Get Report
                                </Button>
                            </Col>
                        </Row>
						<Row>
                            <Col md={2} style={{ marginTop: 10 }}>Application Production Report</Col>
                            <Col md={2}>
                                <Button onClick={this.getAppProductionReport} className="btn btn-default pull-left" style={{ marginTop: 5 }}>
                                    <Glyphicon glyph="glyphicon glyphicon-export" style={{ marginRight: 10 }} />
                                    Get Report
                                </Button>
                            </Col>
                        </Row>
						<Row>
                            <Col md={2} style={{ marginTop: 10 }}>Discount Code Report</Col>
                            <Col md={2}>
                                <Button onClick={this.getDiscountCodeReport} className="btn btn-default pull-left" style={{ marginTop: 5 }}>
                                    <Glyphicon glyph="glyphicon glyphicon-export" style={{ marginRight: 10 }} />
                                    Get Report
                                </Button>
                            </Col>
                        </Row>
						<Row>
                            <Col md={2} style={{ marginTop: 10 }}>PayPal VOB Report</Col>
                            <Col md={2}>
                                <Button onClick={this.getPayPalVOBReport} className="btn btn-default pull-left" style={{ marginTop: 5 }}>
                                    <Glyphicon glyph="glyphicon glyphicon-export" style={{ marginRight: 10 }} />
                                    Get Report
                                </Button>
                            </Col>
                        </Row>
						<Row>
                            <Col md={2} style={{ marginTop: 10 }}>Denial Report</Col>
                            <Col md={2}>
                                <Button onClick={this.getDenialReport} className="btn btn-default pull-left" style={{ marginTop: 5 }}>
                                    <Glyphicon glyph="glyphicon glyphicon-export" style={{ marginRight: 10 }} />
                                    Get Report
                                </Button>
                            </Col>
                        </Row>
                    </Box>
                </ContentBody>
            </React.Fragment>
        );
    }
}

export default ReportManagement;


// WEBPACK FOOTER //
// ./src/areas/admin/reportManagement/ReportManagement.js